<template>
  <div class="page-add page">
    <div class="pageTitleBox">
      <div class="boxNameL">新建库存盘点</div>
      <div class="boxNameR">
        <el-button type="warning" @click="$router.back()" size="small">返回</el-button>
      </div>
    </div>
    <div style="background-color: #fff; min-height: 500px">
      <el-form class="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="门店:" :label-width="'102px'" required>
              <el-select class="input" v-model="selectShopId" placeholder="请选择" size="small" style="width: 140px">
                <el-option :label="item.shop_name" :value="item.shop_id" v-for="item in userInfo.shops"
                  :key="item.shop_id"></el-option>
              </el-select>
              <el-button type="warning" size="small" @click="handleSelectGoodsClick(1)">选择商品</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            录入条码：
            <el-input size="mini" style="width: 150px" v-model="scanningCodeInput"
              @keyup.enter.native="clickScanningCodeInput" placeholder="请录入条码">
            </el-input>
          </el-col>
        </el-row>
      </el-form>

      <el-table :data="shopTable" style="width: 100%; margin-top: 10px" ref="table">
        <el-table-column label="名称" prop="name"> </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            <span>{{ scope.row.param_sku_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位">
          <template slot-scope="scope">
            <span>{{ scope.row.param_packing_way_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <div v-if="scope.row.goodsType == 1 && scope.row.param_packing_way_name != scope.row.param_packing_way_unit">
              <el-input-number v-model="scope.row.numMax" controls-position="right" :min="0" size="small"
                @change="handleChange1(scope)"></el-input-number>
              <span>{{ scope.row.param_packing_way_name }}</span>
              <el-input-number v-model="scope.row.numMin" controls-position="right" :min="0" size="small"
                @change="handleChange2(scope)"></el-input-number>
              <span>{{ scope.row.param_packing_way_unit }}</span>
            </div>
            <div v-else> <el-input-number v-model="scope.row.num" controls-position="right" :min="0" size="small"
                @change="handleChange(scope)"></el-input-number>
              <span>{{ scope.row.param_packing_way_name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="库存">
          <template slot-scope="scope">

            <span v-if="scope.row.stock.length > 0 && Array.isArray(scope.row.stock)"><span
                v-for="(stockItem, index) in scope.row.stock" :key="index"> {{ stockItem.shop_name }}:{{
          stockItem.shop_stock
        }}</span></span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button style="color: #ff4000" icon="el-icon-delete" type="text"
              @click="deleteGoods(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="padding: 20px 0; background-color: #fff">
      <el-form>
        <el-row>
          <el-col :span="2"> </el-col>
        </el-row>
        <el-row>
          <el-col> </el-col>
          <el-col :span="2" :offset="22">
            <el-button type="warning" @click="submitForm" size="small">提交</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 添加商品弹框 -->
    <div v-if="dialogAddShop_state">
      <dialogAddShop @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state"
        :selectType.sync="selectType" @submit="selectShop" :tree.sync="tree"></dialogAddShop>
    </div>
    <el-dialog :visible.sync="dialogWay_state" :close-on-click-modal="false" :show-close="false" :width="'300px'">
      <div slot="title">
        <span>售卖方式</span>
      </div>
      <div style="
          font-size: 16px;
          color: red;
          margin-bottom: 25px;
          text-align: center;
        "></div>
      <el-radio-group v-model="dialogWay_curId" style="text-align: center; width: 100%">
        <el-radio :label="item.packing_way_id" v-for="(item, index) in dialogWay_obj.saleWays" :key="index">
          {{ item.packing_way_name }}
        </el-radio>
      </el-radio-group>
      <div slot="footer">
        <el-row style="text-align: center">
          <el-button type="cancel" @click="cancel_dialogWay">取消</el-button>
          <el-button type="success" @click="submit_dialogWay(dialogWay)">确定</el-button>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import delSale from "../../../util/delSale.js";
import dialogAddShop from "../../../components/dialog_addShop";
export default {
  components: {
    dialogAddShop,
  },
  data() {
    return {
      selectShopId: "",
      dialogWay_obj: {},
      dialogWay: {},
      dialogWay_curId: "",
      params: {
        id: "",
        outDate: new Date().getTime(),
        remark: "",
      },
      dialogAddShop_state: false, //新增商品弹框状态
      dialogWay_state: false,
      scanningCodeInput: "",
      o: null,
      tableData: [],
      shopTable: [],
      //记录调拨条码
      acceptanceParam: {
        code_list: [],
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    curShopId() {
      return this.$store.state.shopId;
    },
  },
  mounted() {
    this.o = new delSale();
  },
  methods: {
    handleChange1(scope) {
      let numMax = 0;
      numMax += scope.row.numMax;
      let num = 0;
      num = scope.row.numMax * scope.row.param_in_exchanage
      this.$set(this.shopTable[scope.$index], ['numMax'], numMax);
      this.$set(this.shopTable[scope.$index], ['num'], num);
    },
    handleChange2(scope) {
      let numMin = 0;
      numMin += scope.row.numMin;
      let num = 0;
      this.$set(this.shopTable[scope.$index], ['numMin'], numMin);
      num = scope.row.numMax * scope.row.param_in_exchanage + scope.row.numMin
      this.$set(this.shopTable[scope.$index], ['num'], num);
    },
    handleChange(scope) {
      let num = 0;
      num += scope.row.num;
      this.$set(this.shopTable[scope.$index], ['num'], num);
    },
    //已选中商品
    selectShop(val) {
      let shopObj = {
        param_type_id: val.goodsType + "",
      };
      //添加商品
      if (val.goodsType == 0) {
        //商品类目
        shopObj.param_type_name = "商品"; //类型名字
        shopObj.id = val.goodsItem.goodsId; //商品id
        shopObj.name = val.goodsItem.title; //商品名字
        shopObj.barcode = '';
        shopObj.num = 0; //商品名字
        shopObj.goodsType = 0; //商品名字
        shopObj.param_sku_id = val.skuItem._id; //规格id
        shopObj.param_sku_name = val.skuItem.skus_name; //规格
        shopObj.param_packing_way_id = val.wayItem.packing_way_id; //包装方式id
        shopObj.param_packing_way_name = val.wayItem.packing_way_name; //包装方式名称
        shopObj.stock = val.skuItem.stock_detail; //库存
      } else if (val.goodsType == 1) {
        //医疗
        shopObj.param_type_name = "医疗"; //类型名字
        shopObj.id = val.goodsItem.medical_id; //商品id
        shopObj.name = val.goodsItem.title; //商品名字
        shopObj.num = 0; //商品名字
        shopObj.numMax = 0; //商品名字
        shopObj.numMin = 0; //商品名字
        shopObj.goodsType = 1; //商品名字
        shopObj.param_sku_id = ""; //规格id
        shopObj.param_sku_name = val.skuItem.sku_value; //规格
        shopObj.param_packing_way_id = val.skuItem.unit; //包装方式最大单位
        shopObj.param_packing_way_unit = val.skuItem.unit; //包装方式最小单位
        shopObj.param_packing_way_name = val.skuItem.in_unit; //包装方式名称
        shopObj.param_in_exchanage = val.skuItem.in_exchanage; //出库单位
        shopObj.stock = val.goodsItem.stock_detail; //库存
      } else if (val.goodsType == 7) {
        //医疗
        shopObj.param_type_name = "耗材"; //类型名字
        shopObj.id = val.goodsItem.consumablematerial_id; //商品id
        shopObj.name = val.goodsItem.title; //商品名字
        shopObj.num = 0; //商品名字
        shopObj.goodsType = 7; //商品名字
        shopObj.param_sku_id = ""; //规格id
        shopObj.param_sku_name = ""; //规格
        shopObj.barcode = '';
        shopObj.param_packing_way_id = val.wayItem.packing_unit; //包装方式id
        shopObj.param_packing_way_name = val.wayItem.packing_unit; //包装方式名称
        shopObj.stock = val.skuItem.stock_detail; //库存
      }
      shopObj.param_custom_code = ""; //芯片编号
      for (let i = 0; i < this.shopTable.length; i++) {
        if (shopObj.param_type_id == 0) {
          if (
            shopObj.id == this.shopTable[i].id &&
            shopObj.param_sku_id == this.shopTable[i].param_sku_id &&
            shopObj.param_packing_way_id ==
            this.shopTable[i].param_packing_way_id
          ) {
            this.$message({
              type: "error",
              message: "已重复添加",
            });
            return;
          }
        } else {
          if (
            shopObj.id == this.shopTable[i].id &&
            shopObj.param_sku_id == this.shopTable[i].param_sku_id
          ) {
            this.$message({
              type: "error",
              message: "已重复添加",
            });
            return;
          }
        }
      }
      this.shopTable.push(shopObj);
      this.$message({
        type: "success",
        message: "已添加",
      });

    },
    cancel_dialogWay() {
      this.dialogWay_state = false;
    },
    clickScanningCodeInput() {
      this.getScanData(this.scanningCodeInput);
      this.$nextTick(() => {
        this.scanningCodeInput = "";
        this.curIndex = -1;
      });
    },
    submit_dialogWay(dialogWay) {
      this.dialogWay_state = false;
      let wayItem = this.$public.getMatchingItem(
        this.dialogWay_obj.saleWays,
        "packing_way_id",
        this.dialogWay_curId
      );
      let obj = {}
      obj.id = dialogWay.goodsId;
      obj.name = dialogWay.goodsName;
      obj.barcode = dialogWay.barcode;
      obj.num = 0;
      obj.goodsType = 0;
      obj.unitId = wayItem.packing_way_id;
      obj.unit = wayItem.packing_way_name;
      obj.param_sku_id = dialogWay.skus;
      obj.param_sku_name = dialogWay.skuValue;
      obj.param_packing_way_id = wayItem.packing_way_id; //包装方式id
      obj.param_packing_way_name = wayItem.packing_way_name; //包装方式名称
      obj.stock = dialogWay.stock; //包装方式名称
      this.shopTable.push(obj)


    },
    getScanData(code) {
      this.o.searchGood(code).then((res) => {
        // 602f1e88c904d9db7ccf3bec 医疗类一级分类id
        if (res.category_list[0]._id === "602f1e88c904d9db7ccf3bec") {
          this.$message({
            message: "该商品属于医疗用品，不可在门店业务模块售卖！",
            type: "error",
          });
          return;
        }
        if (res.saleWays == null || res.saleWays == undefined) {
          res.saleWays = [];
        }
        if (res.saleWays.length > 1) {
          // 多售卖方式
          this.dialogWay_curId = "";
          this.dialogWay_obj = {
            saleWays: res.saleWays,
          };
          this.dialogWay = res;
          this.dialogWay_state = true;
        } else {
          let wayItem = res.saleWays;
          let obj = {}
          obj.unitId = wayItem[0].packing_way_id;
          obj.unit = wayItem[0].packing_way_name;
          obj.id = res.goodsId;
          obj.name = res.goodsName;
          obj.barcode = res.barcode;
          obj.num = 0;
          obj.goodsType = 0;
          obj.param_sku_id = res.skus;
          obj.param_sku_name = res.skuValue;
          obj.param_packing_way_id = wayItem[0].packing_way_id; //包装方式id
          obj.param_packing_way_name = wayItem[0].packing_way_name; //包装方式名称
          obj.stock = res.stock; //包装方式名称
          this.shopTable.push(obj)
        }
      });
    },
    //选择商品
    handleSelectGoodsClick(type) {
      if (type == 1) {
        this.dialogAddShop_state = true;
        this.selectType = type;
        this.tree = [
          {
            //显示所需要类目
            id: "602f1e89c904d9db7ccf3c03", //商品
          },
          {
            id: "602f1e88c904d9db7ccf3bec", //医疗
          }, {
            id: "6049cf035a0dfcc381f9311a" //耗材
          },

        ];
      }
    },

    // 100000247621
    // 提交
    submitForm() {
      if (this.selectShopId.length === 0) {
        this.$message({
          message: "选择门店",
          type: "error",
        });
        return;
      }
      if (this.shopTable.length === 0) {
        this.$message({
          message: "请加入要盘点的的商品",
          type: "error",
        });
        return;
      }
      let outOrderItems = [];
      for (let i = 0; i < this.shopTable.length; i++) {
        let goods = this.shopTable[i];
        let item = {
          productId: goods.id,
          skuId: goods.param_sku_id,
          unitId: goods.param_packing_way_id,
          count: goods.num,
          productType: goods.goodsType,
        };
        outOrderItems.push(item);
      }
      let params = {
        inventoryUserId: this.userInfo.uid,
        inventoryUserName: this.userInfo.uName,
        items: outOrderItems,
      };
      this.$confirm(
        "提交后将自动申请通过，请谨慎操作。确定提交?",
        "提示",
        {
          confirmButtonText: "确定提交",
          cancelButtonText: "我再核对一下",
          type: "warning",
        }
      ).then(() => {
        let loading = this.$loading();
        let http;
        params.shopId = this.selectShopId;
        http = this.$http.post(
          process.env.VUE_APP_Url66 + "api/inventory/shop/inventory",
          params
        );
        http.then((res) => {
          loading.close();
          if (res.code == 0) {
            if (res.code == 0) {
              this.$router.back();
            }
          }
        });
      });
    },
    // 删除添加的商品
    deleteGoods(index, index2) {
      this.$confirm("确认删除该商品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.shopTable.splice(index2, 1);
      });
    },

  },
};
</script>
<style lang="scss">
.page-add {
  .pageTitleBox {}

  .form {
    padding: 16px 0 0 0;

    .el-form-item {
      margin-bottom: 0;

      .el-form-item__label {
        color: $fontColor;
      }
    }
  }

  .wrapper {
    .tit {
      font-size: 16px;
      margin-bottom: 28px;
      background-color: #f5f5f5;
      height: 40px;
      line-height: 40px;
      border-radius: 3px;

      .name {
        margin-left: 20px;
      }

      .day {
        color: #666;
      }
    }
  }
}

.row-expand-cove .el-table__expand-icon {
  display: none;
}

.el-table .sort-caret.descending {
  border-top-color: #000;
}

.el-table .sort-caret.ascending {
  border-bottom-color: #000;
}

.outinput {
  border: none;
  border-bottom: 1px solid #333;
  width: 35px;
  height: 27px;
  margin-right: 10px;

  .el-input__inner {
    text-align: center;
    padding: 2px;
    background: none;
    border: 0;
    height: 25px;
    line-height: 25px;
  }
}
</style>
